export default {
  data() {},
  methods: {
    getStatusColor(status) {
      if (status === 'FAIL') return 'danger'
      return 'success'
    },
    getDocType(type) {
      switch (type) {
        case '01': {
          return 'INVOICE'
        }
        case '02': {
          return 'CREDIT NOTE'
        }
        case '03': {
          return 'DEBIT NOTE'
        }
        case '04': {
          return 'REFUND NOTE'
        }
        case '11': {
          return 'SELF-BILLED INVOICE'
        }
        case '12': {
          return 'SELF-BILLED CREDIT NOTE'
        }
        case '13': {
          return 'SELF-BILLED DEBIT NOTE'
        }
        case '14': {
          return 'SELF-BILLED REFUND NOTE'
        }
      }
    },
  },
}

//'INVOICE' = '01',
//   'CREDIT NOTE' = '02',
//   'DEBIT NOTE' = '03',
//   'REFUND NOTE' = '04',
//   'SELF-BILLED INVOICE' = '11',
//   'SELF-BILLED CREDIT NOTE' = '12',
//   'SELF-BILLED DEBIT NOTE' = '13',
//   'SELF-BILLED REFUND NOTE' = '14',
